import ApiService from '@/plugins/apiService'
import { get, find } from 'lodash-es'

export default {
  state: {
    routes: {}
  },

  mutations: {
    SET_ROUTES (state, routes) {
      state.routes = routes
    }
  },

  getters: {
    getRoutes: state => path => {
      return get(state.routes, path)
    },

    getInstructionRoute: state => name => {
      const {
        id: instructionId,
        categoryId: instructionsCategoryId
      } = find(state.routes.instructions.details, { name })

      return { instructionId, instructionsCategoryId }
    }
  },

  actions: {
    async fetchRoutes ({ commit }) {
      const { data } = await ApiService.getRoutes()
      commit('SET_ROUTES', data)
    }
  }
}
